import { render, staticRenderFns } from "./CampaignsKeywordsGridHeadline.vue?vue&type=template&id=0b79fd82"
import script from "./CampaignsKeywordsGridHeadline.vue?vue&type=script&lang=ts"
export * from "./CampaignsKeywordsGridHeadline.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsKeywordsGridHeadline.vue?vue&type=style&index=0&id=0b79fd82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports